module.exports = __webpack_public_path__ + "media/components/maps/forms/images/restriction-zone-red-8d5fac0d1de7d1f2115a98c545e31fed.svg";